import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

const styles = theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)(props => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

export default class ExercisePreviewButton extends Component {
	state = {
		open: false
	};

	render() {
		const { exercise } = this.props;
		const { open } = this.state;
		return (
			<div>

				<Dialog onClose={() => this.setState({ open: false })} aria-labelledby="customized-dialog-title" open={open}>
					<DialogTitle id="customized-dialog-title" onClose={() => this.setState({ open: false })}>
						Preview
        			</DialogTitle>
					<DialogContent dividers>
						<Typography gutterBottom>
							<div className="modalBody modal-content" style={{ width: 320 }}>
								<div style={{
									display: 'flex',
									flexDirection: 'column'
								}}>
									<div style={{
										display: 'flex',
										justifyContent: 'center',
										width: '100%'
									}}>
										<video  controls src={exercise.videoUrl}  autoPlay style={{ width: '100%', height: 200, objectFit: 'contain' }} loop />
									</div>
									<div style={{
										backgroundColor: COLORS.greyFour,
										padding: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}>
										<div style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center'
										}}>
											<div style={{
												width: 'fit-content',
												background: COLORS.greyThree,
												borderRadius: 2,
												padding: '3px 5px',
												color: COLORS.greyFour
											}}>
												Category
											</div>
											<div style={{
												fontWeight: 'bold',
												textAlign: 'center',
												wordBreak: 'break-word'
											}}>
												{exercise.name}
											</div>
											<div style={{
												fontWeight: 'bold',
												marginTop: 10
											}}>
												Description
											</div>
											<div style={{ textAlign: 'left', wordBreak: 'break-word' }}>
												{exercise.description}
											</div>
										</div>
									</div>
								</div>
							</div>
						</Typography>
					</DialogContent>
				</Dialog>
				<span
					className="link"
					onClick={() => this.setState({ open: true })}
					style={{ float: 'right' }}>
					<FontAwesomeIcon icon="eye" title={'Preview'}
						style={{ marginRight: 5, color: COLORS.orange }} />
				</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ExercisePreviewButton.js